import React from "react";

const SidebarHeading = ({ heading }: { heading: string }) => {
  return (
    <div
      id={heading.toString().replace(/\s+/g, "")}
      className="pb-1 pl-2 text-gray-900 dark:text-white"
    >
      {heading}
    </div>
  );
};

export default SidebarHeading;
